import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { MobMaskModule } from '../shared/directives/mob-mask/mob-mask.module';
import { AddCardModule } from '../shared/modules/add-card/add-card.module';
import { ProfileAdBannerModule } from '../shared/modules/profile-ad-Banner/profile-ad-Banner.module';
import { ReceivingHoursAlertBannerModule } from '../shared/modules/receiving-hours-alert-banner/receiving-hours-alert-banner.module';
import { ReceivingHoursModule } from '../shared/modules/receiving-hours/receiving-hours.module';
import { AccountComponent } from './account/account.component';
import { BillingComponent } from './billing/billing.component';
import { CustomProfileAndPreferencesComponent } from './custom-profile-and-preferences/custom-profile-and-preferences.component';
import { InfluenzaProfileComponent } from './influenza-profile/influenza-profile.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { PaymentComponent } from './payment/payment.component';
import { UserComponent } from './user/user.component';
import { CustomUserRegistrationModule } from "../custom-user-registration/custom-user-registration.module";
import { ProfilePreferenceBannerModule } from './profile-preference-banner/profile-preference-banner.module';

@NgModule({
  declarations: [
    CustomProfileAndPreferencesComponent,
    MyAccountComponent,
    UserComponent,
    AccountComponent,
    PaymentComponent,
    InfluenzaProfileComponent,
    BillingComponent,
  ],
  exports: [
    CustomProfileAndPreferencesComponent,
    MyAccountComponent,
    UserComponent,
    AccountComponent,
    PaymentComponent,
    InfluenzaProfileComponent,
    BillingComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserModule,
    I18nModule,
    FormsModule,
    AddCardModule,
    ProfileAdBannerModule,
    MobMaskModule,
    ReceivingHoursModule,
    ReceivingHoursAlertBannerModule,
    ProfilePreferenceBannerModule,
    CustomUserRegistrationModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountProfilePreferenceComponent: {
          component: () =>
            import(
              './custom-profile-and-preferences/custom-profile-and-preferences.component'
            ).then((m) => m.CustomProfileAndPreferencesComponent),
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class CustomProfileAndPreferencesModule { }